"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductList = exports.StyledDialogContent = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const product_list_component_1 = require("../../../../product-editor/table/classify-modal/product-list.component");
exports.StyledDialogContent = (0, styled_components_1.default)(material_1.DialogContent) `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  padding: 0;
  width: 500px;
`;
exports.StyledProductList = (0, styled_components_1.default)(product_list_component_1.ProductList) `
  &&.MuiPaper-root.MuiAccordion-root {
    box-shadow: none;

    &.Mui-expanded {
      margin: 0;
    }
  }
`;
